import React from "react";

const InboxFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 23">
        <g fill={color} fillRule="nonzero">
            <path d="M21.316 11.5h-1.615a5.531 5.531 0 01-4.916 3h-3.517v2c0 1.654 1.352 3 3.014 3h2.304l2.868 2.854a.503.503 0 00.857-.354v-2.5h1.005a3.01 3.01 0 003.014-3v-2c0-1.654-1.352-3-3.014-3z" />
            <path d="M19.306 9V5c0-2.481-2.028-4.5-4.521-4.5H4.737C2.244.5.215 2.519.215 5v4c0 2.481 2.029 4.5 4.522 4.5h.502V17c0 .444.543.668.857.354L9.97 13.5h4.816c2.493 0 4.521-2.019 4.521-4.5z" />
        </g>
    </svg>
);

export default InboxFilled;
